import React from 'react';

import { Modal, Button } from 'react-bootstrap';

class DiversionModal extends React.Component {
  render() {
    const { show, onClose, content } = this.props;

    return (
      <Modal
        show={ show }
        onHide={ onClose }
        className="assistance-table-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Additional Details</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          { content }
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ onClose }>
            <small>Close</small>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DiversionModal;



// WEBPACK FOOTER //
// ./src/components/Diversion/DiversionModal.js